import { AWAY_MESSAGE_DEFAULT_TEXT } from '../../models/messaging-profile';
import { MODEL_NAMES } from '../../constants/index';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import MessagingRoutesBaseHandler from './base-handler.js';

export default class MessagingRoutesAwayMessageEditHandler extends MessagingRoutesBaseHandler {
  @service messaging;
  @service store;

  @tracked customAwayMessage;

  get currentProfile() {
    return this.messaging.currentProfile;
  }

  get isCustomAwayMessageUnsaved() {
    return this.customAwayMessage !== this.currentProfile?.awayMessageText;
  }

  onVisit = task({ drop: true }, async () => {
    this.customAwayMessage = this.currentProfile?.awayMessageText || AWAY_MESSAGE_DEFAULT_TEXT;
  });

  updateAwayMessage = task({ drop: true }, async awayMessage => {
    await this.store
      .adapterFor(MODEL_NAMES.PROFILE)
      .updateAwayMessage(this.currentProfile.id, awayMessage);

    this.currentProfile.awayMessageText = awayMessage;
  });
}
